module.exports = __webpack_public_path__ + "static/media/mobile-app-self-check-in-it.c4a37963.png";